import React from "react";

import { UpdateParameterValues } from "../services/City";
function LandAnalysis(props) {
  const [value, setValue] = React.useState(null);

  const [IsStyle, SetStyle] = React.useState("form-control construction");

  const [structureType, SetstructureType] = React.useState("Per Home");
  React.useEffect(() => {
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.id == 243) {
      SetStyle("form-control construction leftTop");
    }
    if (props.id == 246) {
      SetStyle("form-control construction ");
    }
    if (props.id == 245 || props.id == 175 || props.id == 248 || props.id == 47) {
      SetStyle("form-control construction ");
    }
    if (props.id == 244) {
      SetStyle("form-control construction RightTop ");
    }
    if (props.id == 247) {
      SetStyle("form-control construction leftBottom");
    }
    if (props.id == 47) {
      SetStyle("form-control construction RightBottom ");
    }
    if (props.id == 226) {
      SetStyle("form-control construction leftTop leftBottom");
    }
    if (props.id == 280) {
      SetStyle("form-control construction RightBottom RightTop Prowidth2");
    }
    if (props.id == 181) {
      SetStyle("form-control  Prowidth2");
    }
  }, []);



  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    UpdateParameterValues(structuretype, props);
  }


  if (props.id == 227) {
    return (
      <>
        <div class="row" style={{ marginTop: "5%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "100%" }}>
          <div class="col-md-5" ></div>
          <div class="col-md-3 col-7" style={{ marginTop: "3%" }}>
            <div class="from  justify-content-between  align-items-center ">
              <label class="mr-1 mtop" style={{ marginTop: "5%" }}><u>{props.name.split('Per')[0]} </u>
              </label>



            </div>
          </div>
          <div class="col-md-3 col-5" style={{ marginTop: "3%" }}>
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}

                readOnly
                class="form-control construction"
                style={{ borderRadius: "5px", fontWeight: "550" }}
              />
            </div>
          </div>
        </div>

      </>
    );
  }

  if (props.id == 243 || props.id == 147 || props.id == 244) {
    if (props.id == 243) {
      return (

        <>
          <div class="col-md-12 input-box1 ">
            <div class="row" style={{ width: "107%" }}>
              <div class="col-md-3"></div>
              <div class="col-md-2 col-2"><label class="d-block text-center">Per sqft </label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col-5"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-3" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="mr-1 mtop">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ borderBottom: "2px solid" }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  //placeholder={props.name.split('Per')[0]}
                  readOnly
                  class={IsStyle}
                  style={{ borderBottom: "2px solid" }}
                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 226 || props.id == 248) {
    if (props.id == 226) {

      return (

        <>
          <div class="col-md-5" style={{ marginTop: "2%" }}>
            <div class="from  justify-content-between  align-items-center ">
              <label class="mr-1 mtop">- Closing Cost


              </label>



            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5" style={{ marginTop: "2%" }}>
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {

      return (

        <>


          <div class="col-md-2 col" style={{ marginTop: "2%" }}>
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }

  }



  if (props.id == 247 || props.id == 148 || props.id == 47) {
    if (props.id == 247) {

      return (
        <>
          <div class="col-md-3" >
            <div class="from  justify-content-between  align-items-center ">
              <label class="mr-1 mtop"><u>{props.name.split('Per')[0]}</u>
              </label>



            </div>
          </div>

          <div class="col-md-2 col-2">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  style={{ borderTop: "2px solid", fontWeight: "550" }}
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      if (props.id == 47) {

        return (

          <>


            <div class="col-md-3 col-5">
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}

                    style={{ borderTop: "2px solid", fontWeight: "550" }}
                    class={IsStyle}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </>
        );

      }
      else {

        return (

          <>


            <div class="col-md-3 col-5">
              <div class="from  justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    style={{ borderTop: "2px solid", fontWeight: "550" }}
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );

      }

    }

  }
  else if (props.id == 170 || props.id == 245 || props.id == 172 || props.id == 175 || props.id == 45 || props.id == 246 || props.id == 181 || props.id == 280) {

    if (props.id == 170 || props.id == 172 || props.id == 114 || props.id == 113) {

      return (
        <>
          <div class="col-md-5">
            <div class="from  justify-content-between  align-items-center ">
              <label class="mr-1 mtop">- {props.name.split('Per')[0]}
              </label>
            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input

                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 45) {

      return (
        <>
          <div class="col-md-5">
            <div class="from  justify-content-between  align-items-center ">
              <label class="mr-1 mtop">- {props.name.split('Per')[0]}


              </label>
            </div>
          </div>
          <div class="col-2 ismobile"></div>
          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input

                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );

    }
    else if (props.id == 246) {

      return (
        <>

          <div class="col-md-2 col">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );


    }
    else if (props.id == 280) {
      return (
        <>

          <div class="col-md-1 col-2" style={{ marginTop: "2%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test2">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );

    }
    else if (props.id == 181) {

      return (
        <>

          <div class="col-md-1 col-2">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test2">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );

    }
    else {
      return (
        <>

          <div class="col-md-3 col-5">
            <div class="from  justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}

                  readOnly
                  class={IsStyle}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }



  else {

    return (
      <>
        <div class="col-md-3">
          <div class="from  justify-content-between  align-items-center ">
            <label class="mr-1 mtop">{props.name.split('Per')[0]}

            </label>



          </div>
        </div>
        <div class="col-md-3 col-5">
          <div class="from  justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}

                readOnly
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default LandAnalysis;
